import { Children, PropsWithChildren, ReactNode, useRef } from 'react';

import { assignInlineVars } from '@vanilla-extract/dynamic';
import cn from 'classnames';

import { useResizeObserver } from '../../hooks/useResizeObserver';

import * as css from './GridTable.css';

export const GridTableRow = ({ children }: PropsWithChildren) => {
    const columnsCount = Children.count(children);
    return Children.map(children, (child, idx) => (
        <div className={cn(css.column, idx === 0 && css.firstColumn, idx + 1 === columnsCount && css.lastColumn)}>
            {child}
        </div>
    ));
};

type GridTableProps = { header: ReactNode };

export const GridTable = ({ header, children }: PropsWithChildren<GridTableProps>): ReactNode => {
    const rootRef = useRef<HTMLDivElement>(null);
    const columnsCount = Children.count(header);

    const { width = 0, height = 0 } = useResizeObserver({ ref: rootRef });
    const columnWidth = width / 4;

    return (
        <div className={css.root} ref={rootRef}>
            <div className={css.body} style={assignInlineVars({ [css.columnVar]: columnsCount.toString() })}>
                {Children.map(header, (header) => (
                    <div className={cn(css.header)}>{header}</div>
                ))}
                {children}
            </div>
            {Array.from({ length: columnsCount - 1 }).map((_, idx) => (
                <div
                    key={idx}
                    className={css.divider}
                    style={assignInlineVars({
                        [css.leftVar]: `${columnWidth * (idx + 1)}px`,
                        [css.heightVar]: `${height}px`,
                    })}
                />
            ))}
        </div>
    );
};
